import React from "react";
import { confBadge } from "../../lib/growth";

export default function ConfidenceBadge({ level }) {
  const c = confBadge(level);
  return (
    <span className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide"
      style={{ background: c.bg, color: c.color }} data-testid={`confidence-${(level || "estimated").toLowerCase()}`}>
      {c.label}
    </span>
  );
}
